module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/tags-container/tags-container.style.scss
// module id = 883
// module chunks = 2